namespace GeniuzPOS.AdvPromo {
    export interface AdvancedPromoReportRow {
        PromoCampaign?: string;
        PromoCampName?: string;
        PmExtCode?: string;
        PmId?: string;
        PmDesc?: string;
        PmGroupId?: string;
        PromoApproveFg?: number;
        PmGroupDesc?: string;
        PmType?: number;
        PPtype?: number;
        PmTypeDesc?: string;
        StartPromoDate?: string;
        EndPromoDate?: string;
        PromoTimeFg?: number;
        StartPromoTime?: string;
        EndPromoTime?: string;
        PromoDayFg?: number;
        PromoDay?: string;
        PromoShopFg?: number;
        PromoShop?: string;
        PromoCustFg?: number;
        PromoCust?: string;
        VenderSharing?: number;
        PromoStatus?: PostStatus;
        ItemList?: Adv05ItemDetailsRow[];
        ItemExList?: Adv05ItemExDTsRow[];
    }

    export namespace AdvancedPromoReportRow {
        export const idProperty = 'PmId';
        export const nameProperty = 'PromoCampaign';
        export const localTextPrefix = 'AdvPromo.AdvancedPromoReport';
        export const lookupKey = 'AdvPromo.AdvancedPromoReport';

        export function getLookup(): Q.Lookup<AdvancedPromoReportRow> {
            return Q.getLookup<AdvancedPromoReportRow>('AdvPromo.AdvancedPromoReport');
        }
        export const deletePermission = '4ADVANCED_PROMOTION:รายงาน:รายการสินค้าร่วมโปร:View';
        export const insertPermission = '4ADVANCED_PROMOTION:รายงาน:รายการสินค้าร่วมโปร:View';
        export const readPermission = '4ADVANCED_PROMOTION:รายงาน:รายการสินค้าร่วมโปร:View';
        export const updatePermission = '4ADVANCED_PROMOTION:รายงาน:รายการสินค้าร่วมโปร:View';

        export declare const enum Fields {
            PromoCampaign = "PromoCampaign",
            PromoCampName = "PromoCampName",
            PmExtCode = "PmExtCode",
            PmId = "PmId",
            PmDesc = "PmDesc",
            PmGroupId = "PmGroupId",
            PromoApproveFg = "PromoApproveFg",
            PmGroupDesc = "PmGroupDesc",
            PmType = "PmType",
            PPtype = "PPtype",
            PmTypeDesc = "PmTypeDesc",
            StartPromoDate = "StartPromoDate",
            EndPromoDate = "EndPromoDate",
            PromoTimeFg = "PromoTimeFg",
            StartPromoTime = "StartPromoTime",
            EndPromoTime = "EndPromoTime",
            PromoDayFg = "PromoDayFg",
            PromoDay = "PromoDay",
            PromoShopFg = "PromoShopFg",
            PromoShop = "PromoShop",
            PromoCustFg = "PromoCustFg",
            PromoCust = "PromoCust",
            VenderSharing = "VenderSharing",
            PromoStatus = "PromoStatus",
            ItemList = "ItemList",
            ItemExList = "ItemExList"
        }
    }
}
